import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { DashboardList as AVPDashboardList } from '@atlassian/jsm-enterprise-reports-common/src/ui/new-avp-experience/dashboard-list';
import type { AssetsReportsV2Props } from '../../common/types.tsx';
import { getHostingProduct } from '../../common/utils.tsx';
import { PreferenceBanner } from '../../common/ui/preference-banner/index.tsx';
import { isNewReportsNavExperienceEnabled } from '../../common/feature-gate-helpers.tsx';

export const DashboardList = ({ workspaceId }: AssetsReportsV2Props): React.JSX.Element => {
	const apiPrefix = `/gateway/api/avp/embed/workspaceId/${workspaceId}`;
	const dashboardEditableBaseUrl = isNewReportsNavExperienceEnabled()
		? '/jira/assets/dashboards'
		: '/jira/assets/reports';
	return (
		<>
			<PreferenceBanner />
			<AVPDashboardList
				workspaceId={workspaceId}
				apiPrefix={apiPrefix}
				hostingProduct={getHostingProduct()}
				dashboardEditableBaseUrl={dashboardEditableBaseUrl}
				{...(fg('template_details_api_flow') && {
					templatePlaceholderReplacementsApiPath: `/gateway/api/jsm/reporting/assets/workspace/${workspaceId}/template-details`,
				})}
			/>
		</>
	);
};
